import _Object$freeze from "@babel/runtime-corejs3/core-js-stable/object/freeze";export default _Object$freeze({
  blue: {
    900: '#001D6C',
    800: '#002D9C',
    700: '#0043CE',
    600: '#0F62FE',
    500: '#4589FF',
    400: '#78A9FF',
    300: '#A6C8FF',
    200: '#D0E2FF',
    100: '#EBF2FF'
  },
  orange: {
    900: '#8A3A00',
    800: '#B34B00',
    700: '#E05E00',
    600: '#F76800',
    500: '#FF7A1A',
    400: '#FF8F3D',
    300: '#FFA666',
    200: '#FFC499',
    100: '#FFE7D6'
  },
  purple: {
    900: '#461B83',
    800: '#5622A0',
    700: '#6929C4',
    600: '#8A3FFC',
    500: '#A56EFF',
    400: '#BE95FF',
    300: '#D4BBFF',
    200: '#E9DBFF',
    100: '#F1EBFF'
  },
  indigo: {
    900: '#24223F',
    800: '#2D2B50',
    700: '#393564',
    600: '#4F4B8B',
    500: '#5E59A6',
    400: '#7F7AB8',
    300: '#A5A2CD',
    200: '#CBC9E3',
    100: '#E5E4F1'
  },
  green: {
    900: '#025544',
    800: '#00705A',
    700: '#008F75',
    600: '#00A88C',
    500: '#19C8AB',
    400: '#24DBBD',
    300: '#77E9D2',
    200: '#B8F4EA',
    100: '#DFFBF5'
  },
  yellow: {
    900: '#A87600',
    800: '#C78B00',
    700: '#DB9D00',
    600: '#F0B100',
    500: '#FFC505',
    400: '#FFD54C',
    300: '#FFDA61',
    200: '#FFE99A',
    100: '#FFF5D1'
  },
  red: {
    900: '#6B0004',
    800: '#8A0005',
    700: '#AD0007',
    600: '#D60009',
    500: '#FF000B',
    400: '#FF5259',
    300: '#FF7A80',
    200: '#FFB8BB',
    100: '#FFEBEC'
  },
  neutral: {
    black: '#000000',
    900: '#21272A',
    800: '#343A3F',
    700: '#4D5358',
    600: '#697077',
    500: '#878D96',
    400: '#A2A9B0',
    300: '#C1C7CD',
    200: '#DDE1E6',
    100: '#F2F4F8',
    white: '#FFFFFF'
  },
  special: {
    DeltaDental: '#43B02A',
    IMenuOrange: '#F9A500',
    IMenuBlue: '#5B91D6',
    AltusDental: '#007398',
    Unum: '#005298'
  }
});
//# sourceMappingURL=colors.js.map